function cartCheckoutLimit() {
  document.addEventListener("DOMContentLoaded", () => {
    const root = document.querySelector("#main-cart-footer");
    if (!root) return;

    const block = root.querySelector(".cart__ctas");
    const button = root.querySelector("#checkout");

    if (!block || !button) return;

    const limit = parseInt(block.dataset.limit || "0", 10);
    if (!limit) return;

    let lastState = null;

    function applyState(count) {
      const isOverLimit = count > limit;

      if (lastState === isOverLimit) return;
      lastState = isOverLimit;

      button.classList.remove("is-disabled-on-page-load");

      // ✅ ONLY STATE CHANGE (no text manipulation)
      button.classList.toggle("is-disabled", isOverLimit);
    }

    async function getCartCount() {
      try {
        const res = await fetch("/cart.js", { cache: "no-store" });
        const cart = await res.json();
        return cart.item_count || 0;
      } catch (e) {
        console.error("[cart limit] fetch failed", e);
        return 0;
      }
    }

    async function sync() {
      const count = await getCartCount();
      applyState(count);
    }

    sync();

    const cartArea =
      document.querySelector("cart-items") ||
      document.querySelector("form[action*='/cart']") ||
      document.body;

    const observer = new MutationObserver(() => {
      clearTimeout(window.__cartLimitTimer);
      window.__cartLimitTimer = setTimeout(sync, 120);
    });

    observer.observe(cartArea, {
      subtree: true,
      childList: true,
      attributes: true,
    });

    // keep loading state (unchanged logic)
    const cartItems = document.querySelector(".cart__items");

    if (cartItems) {
      let removeTimer = null;

      const updateButtonState = () => {
        const isUpdating = cartItems.classList.contains(
          "cart__items--disabled",
        );

        if (isUpdating) {
          clearTimeout(removeTimer);
          button.classList.add("is-updating");
        } else {
          clearTimeout(removeTimer);
          removeTimer = setTimeout(() => {
            button.classList.remove("is-updating");
          }, 800);
        }
      };

      updateButtonState();

      const loadingObserver = new MutationObserver(updateButtonState);

      loadingObserver.observe(cartItems, {
        attributes: true,
        attributeFilter: ["class"],
      });
    }
  });
}

cartCheckoutLimit();
